export function getSlug(slug: string[]): string {
    return slug.at(-1) || ''
}

export function getContentfulEnvironment() {
    return process.env.CONTENTFUL_ENVIRONMENT;
}


export function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}